import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_GetPermissionLevelsOut, PermissionLevel } from './permissionLevels.types';
import { mapPermissionLevels } from './permissionLevels.mapper';


export class PermissionLevelCatalogService {
  async getPermissionLevels(signal?: AbortSignal): Promise<ApiResponse<PermissionLevel[]>> {
    const response = await apiClient.get<LC_GetPermissionLevelsOut>(
      API_CONFIG.ENDPOINTS.CATALOG.PERMISSION_LEVELS,
      { signal },
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapPermissionLevels(response.data) };
  }
}

export const permissionLevelCatalogService = new PermissionLevelCatalogService();
